import React from 'react';
import { EmojiData, Picker } from 'emoji-mart';
import { t } from '@lingui/macro';

const EmojiPicker: React.FC<{ isRtl: Boolean; onEmojiSelect: (emoji: EmojiData) => void }> = ({
  isRtl,
  onEmojiSelect,
}) => {
  return React.useMemo(() => {
    return (
      <Picker
        emoji={`point_up`}
        title={t`Pick your emoji...`}
        perLine={7}
        darkMode={false}
        style={{
          position: 'absolute',
          bottom: '32px',
          left: isRtl ? '-20px' : 'auto',
          right: isRtl ? 'auto' : '-20px',
        }}
        i18n={{
          search: t`Search`,
          notfound: t`No Emoji Found`,
          categories: {
            search: t`Search Results`,
            recent: t`Frequently Used`,
            people: t`People & Body`,
            nature: t`Animals & Nature`,
            foods: t`Food & Drink`,
            activity: t`Activity`,
            places: t`Travel & Places`,
            objects: t`Objects`,
            symbols: t`Symbols`,
            flags: t`Flags`,
            custom: t`Custom`,
          },
        }}
        onSelect={(emoji: EmojiData): void => {
          onEmojiSelect(emoji);
        }}
      />
    );
  }, [isRtl, onEmojiSelect]);
};

export default EmojiPicker;
